var _rect, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 20,
    fill: "#EAEAEA"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.0514 20.8525H17C13.6863 20.8525 11 23.5388 11 26.8526V26.9996C11 28.1042 11.8954 28.9996 13 28.9996H26.0513C27.1559 28.9996 28.0513 28.1042 28.0513 26.9996V26.8526C28.0513 23.5388 25.3651 20.8525 22.0514 20.8525ZM17 18.8525C12.5817 18.8525 9 22.4343 9 26.8526V26.9996C9 29.2088 10.7909 30.9996 13 30.9996H26.0513C28.2605 30.9996 30.0513 29.2088 30.0513 26.9996V26.8526C30.0513 22.4343 26.4697 18.8525 22.0514 18.8525H17Z",
    fill: "#162C2A"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5269 15.2406C21.2486 15.2406 22.6455 13.8442 22.6455 12.1203C22.6455 10.3964 21.2486 9.00001 19.5269 9.00001C17.8051 9.00001 16.4082 10.3964 16.4082 12.1203C16.4082 13.8442 17.8051 15.2406 19.5269 15.2406ZM19.5269 17.2406C22.3538 17.2406 24.6455 14.9482 24.6455 12.1203C24.6455 9.29243 22.3538 7 19.5269 7C16.6999 7 14.4082 9.29243 14.4082 12.1203C14.4082 14.9482 16.6999 17.2406 19.5269 17.2406Z",
    fill: "#162C2A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/user.71abd4252bac70e0390fe2166f0c1a16.svg";
export { ForwardRef as ReactComponent };